/* eslint-disable */
export default [{
    header: 'Projets & Tâches', action: 'read_all_project', resource: 'Projets',
}, {
    title: "Offres", route: "apps-bids-list", icon: "PaperclipIcon", action: 'read_all_bids', resource: 'Offres',
}, {
    title: 'Projets', route: 'projects-list', icon: 'SaveIcon', action: 'read_all_project', resource: 'Projets',
}, {
    title: 'Chat', route: 'apps-chat-ai', icon: 'MessageSquareIcon', action: 'make_chat', resource: 'Chat',
}, {
    title: 'Tâches', route: 'todos', icon: 'CheckSquareIcon', action: 'read_tasks', resource: 'Tâches',
},]